import { Base } from '@studiometa/js-toolkit';
import { addStyle, map, clamp, damp, transform, nextTick } from '@studiometa/js-toolkit/utils';

/**
 *
 */
export default class Navbar extends Base {
  static config = {
    name: 'Navbar',
  };

  y = 0;
  dampedY = 0;
  dampFactor = 0.04;
  dampFactorAuto = 0.04;
  dampFactorMethod = 0.1;
  lastDirection = null;
  positionY = 0;

  /**
   * targetY
   * @returns {number}
   */
  get targetY() {
    return this.$el.offsetHeight * -1;
  }

  /**
   * setPositionY
   */
  async setPositionY() {
    const sentinel = document.createElement('div');
    addStyle(sentinel, {
      position: 'relative',
      display: 'block',
      height: '1px',
      padding: '0',
      marginBottom: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      borderWidth: '0',
    });
    this.$el.parentNode.insertBefore(sentinel, this.$el);
    await nextTick();
    this.positionY = sentinel.offsetTop;
    sentinel.remove();
  }

  /**
   * Mounted
   */
  mounted() {
    this.setPositionY();
  }

  /**
   * Resized
   */
  resized() {
    this.setPositionY();
  }

  /**
   * Scrolled
   * @param {object} props
   * @param {number} props.y
   * @param {object} props.direction
   * @param {number} props.deltaY
   * @param {number} props.maxY
   */
  scrolled({ y, direction, deltaY, maxY }) {
    const progressFromNavbarPosition = maxY === 0 ? 1 : map(y, this.positionY, maxY, 0, 1);
    if (progressFromNavbarPosition < 0) {
      this.y = 0;
      this.$services.enable('raf');
      return;
    }

    if (progressFromNavbarPosition >= 1) {
      return;
    }

    if (direction.y === 'NONE') {
      if (this.lastDirection === 'UP') {
        this.show();
      } else if (y - this.positionY >= -this.targetY) {
        this.hide();
      }
      return;
    }

    this.lastDirection = direction.y;

    this.dampFactor = this.dampFactorAuto;
    this.y = clamp(this.y - deltaY, 0, this.targetY);
    this.$services.enable('raf');
  }

  /**
   *
   */
  ticked() {
    if (this.y !== this.dampedY) {
      this.dampedY = damp(this.y, this.dampedY, this.dampFactor);
      transform(this.$el, {
        y: this.dampedY,
      });
    }
    if (this.dampedY === this.y) {
      this.$services.disable('raf');
    }
  }

  /**
   *
   */
  show() {
    if (this.dampedY === 0) {
      return;
    }
    this.dampFactor = this.dampFactorMethod;

    if (
      !document.documentElement.classList.contains('is-on-top') &&
      !document.documentElement.classList.contains('is-near-top')
    ) {
      this.$el.classList.add('header--fixed');
    }
    this.y = 0;
    this.$services.enable('raf');
  }

  /**
   *
   */
  hide() {
    if (this.dampedY === this.targetY) {
      return;
    }
    this.dampFactor = this.dampFactorMethod;
    this.y = this.targetY;
    this.$el.classList.remove('header--fixed');
    this.$services.enable('raf');
  }
}
